import { filters } from "../../components/Filters/Filters.ts";
import { pagination } from "../../components/Pagination/Pagination";
import "./news-listing-page.scss";

(function () {
    if (document.querySelectorAll(".js-news-listing-page").length > 0) {

        const newsListingPage = {
            init: function () {
                filters.init();
                filters.get(window.location.search);
                pagination.init();
                newsListingPage.addEventListeners();
            },
            addEventListeners: () => {
                const filterSubmit = document.getElementById("filter-submit");

                if (filterSubmit) {
                    filterSubmit.addEventListener("click", (e) => {
                        e.preventDefault();

                        window.location.search = filters.set();
                    })
                }
            }
        };

        newsListingPage.init();
    }
})();
